/* ------------------------------------------------------------------
   APEX AFFAIR: Sprachauswahl (Stand 28.09.2026)
   - Flaggen-Links zeigen auf die gleiche Seite in der anderen Sprache
   - Wahl wird im Cookie apex_lang gemerkt (1 Jahr)
   - Header-Button mit Flagge links neben dem Konto-Symbol
   Die automatische Erst-Sprache steckt als kleines Inline-Skript
   oben in layout/theme.liquid (muss vor dem Rendern laufen).
------------------------------------------------------------------ */
(function () {
  'use strict';
  var L = window.APEX_LANG || {};
  var LANGS = L.langs || {};
  var CUR = L.cur || (document.documentElement.lang || 'de').slice(0, 2);

  function setCookie(v) {
    document.cookie = 'apex_lang=' + v + '; path=/; max-age=31536000; SameSite=Lax';
  }

  /* Pfad ohne Sprach-Praefix, z. B. /fr/products/x -> /products/x */
  function barePath() {
    var p = location.pathname;
    var root = LANGS[CUR] || '/';
    if (root !== '/' && (p === root || p.indexOf(root + '/') === 0)) p = p.slice(root.length) || '/';
    return p;
  }

  function hrefFor(code) {
    var root = LANGS[code];
    if (!root) return null;
    var p = barePath();
    return (root === '/' ? '' : root) + p + location.search;
  }

  function wire(scope) {
    var links = (scope || document).querySelectorAll('a[data-apex-lang]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-apex-wired')) continue;
      a.setAttribute('data-apex-wired', '1');
      var h = hrefFor(a.getAttribute('data-apex-lang'));
      if (h) a.setAttribute('href', h);
      a.addEventListener('click', function () {
        setCookie(this.getAttribute('data-apex-lang'));
      });
    }
  }

  function buildButton() {
    var tpl = document.getElementById('apex-lang-tpl');
    var host = document.querySelector('header-actions');
    if (!tpl || !host || host.querySelector('.apex-langbtn')) return;

    var wrap = document.createElement('div');
    wrap.className = 'apex-langbtn';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'apex-langbtn__toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Language / Sprache');

    var panel = document.createElement('div');
    panel.className = 'apex-langbtn__panel';
    panel.hidden = true;
    panel.appendChild(tpl.content.cloneNode(true));

    var cur = panel.querySelector('.apex-lang.is-current .apex-flag');
    if (cur) btn.appendChild(cur.cloneNode(true));
    var code = document.createElement('span');
    code.className = 'apex-langbtn__code';
    code.textContent = CUR.toUpperCase();
    btn.appendChild(code);

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      panel.hidden = !panel.hidden;
      btn.setAttribute('aria-expanded', String(!panel.hidden));
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !wrap.contains(e.target)) { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
    });

    wrap.appendChild(btn);
    wrap.appendChild(panel);
    host.insertBefore(wrap, host.firstChild);
    wire(panel);
  }

  function run() {
    wire(document);
    buildButton();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  /* Der Header kann neu gerendert werden: Button bei Bedarf wieder einsetzen. */
  var hc = document.querySelector('header-component') || document.body;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      var host = document.querySelector('header-actions');
      if (host && !host.querySelector('.apex-langbtn')) buildButton();
    }).observe(hc, { childList: true, subtree: true });
  }
})();
